import { memo, CSSProperties } from 'react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

interface LegendIndicatorProps {
  color: CSSProperties['color'];
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: ({ color }: LegendIndicatorProps) => color,
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    marginRight: theme.spacing(1)
  }
}));

const LegendIndicator = ({ color }: LegendIndicatorProps) => {
  const classes = useStyles({ color });
  return <div className={classes.root} />;
};

export default memo(LegendIndicator);
